import { atom as stateSegment } from 'jotai';

interface KnowledgeCenterModal {
  isKnowledgeCenterModalOpen: boolean;
}

export const knowledgeCenterModalAtom = stateSegment<KnowledgeCenterModal>({
  isKnowledgeCenterModalOpen: false,
});

knowledgeCenterModalAtom.debugLabel = 'knowledgeCenterModalAtom';
